// extracted by mini-css-extract-plugin
export default {"warningWrapper":"members-report-article_warningWrapper__4Ly3x"};